/**
 * Inserts `text` at the current selection range of the given input / textarea
 * element, replacing any selected text, and moves the cursor to the end of the
 * inserted content.
 *
 * Dispatches a synthetic `input` event so that Angular forms and other
 * listeners are notified of the value change.
 *
 * @param el   - The native input or textarea element.
 * @param text - The text to insert at the current cursor / selection position.
 */
export function insertTextAtCursor(
  el: HTMLInputElement | HTMLTextAreaElement,
  text: string
): void {
  const start = el.selectionStart ?? el.value.length;
  const end = el.selectionEnd ?? el.value.length;

  el.value = el.value.substring(0, start) + text + el.value.substring(end);
  const cursorPos = start + text.length;
  el.setSelectionRange(cursorPos, cursorPos);

  el.dispatchEvent(new Event('input', { bubbles: true }));
}
